import toast from 'react-hot-toast'
import Modal from './Modal'

interface TokenRevealModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  token: string | null
  description?: string
}

export default function TokenRevealModal({
  isOpen,
  onClose,
  title,
  token,
  description = 'Copy this key now — it will not be shown again.',
}: TokenRevealModalProps) {
  const copyToken = async () => {
    if (!token) return
    try {
      await navigator.clipboard.writeText(token)
      toast.success('API key copied to clipboard')
    } catch {
      toast.error('Failed to copy API key')
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="lg">
      <div className="space-y-4">
        <p className="text-sm text-amber-100">{description}</p>
        {token && (
          <div className="bg-harbor-bg rounded-lg p-3 border border-amber-700/40">
            <code className="text-sm text-amber-100 font-mono break-all">{token}</code>
          </div>
        )}
        <div className="flex gap-3 justify-end">
          {token && (
            <button
              type="button"
              onClick={copyToken}
              className="px-4 py-2 bg-amber-700 text-white text-sm font-medium rounded-lg hover:bg-amber-600 transition-colors"
            >
              Copy key
            </button>
          )}
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 bg-harbor-border text-harbor-text text-sm font-medium rounded-lg hover:bg-harbor-surface-raised transition-colors"
          >
            Done
          </button>
        </div>
      </div>
    </Modal>
  )
}
